import { useFetchAdventures } from "../../api/queries/adventureQueries";
import { BUTTON_TYPE_CLASSES } from "../../components/button/button.component";
import EventCard from "../../components/eventCard/eventCard.component";
import Footer from "../../components/footer/footer.component";
import Hero, { HeroType } from "../../components/hero/hero.component";
import "./eventDirectory.styles.scss";


const EventsDirectory = () => {
    const adventures = useFetchAdventures();
    
    return (
        <>
            <Hero 
                headerPrimary={"Upcoming Events"}
                heroType={HeroType.Minimalist}
            />
            <div className="directory">
                <div className="directory__filters">
                    <form action="#" className="directory__form">
                        <div className="directory__form-group">
                            <select className="directory__form-input" name="difficulty" id="difficulty" defaultValue={0}>
                                <option value="0" disabled>Select Difficulty</option>
                                <option value="1">Beginner</option>
                                <option value="2">Moderate</option>
                                <option value="3">Challenging</option>
                                <option value="4">Strenous</option>
                            </select>
                            <i className="fa-solid fa-chevron-down"></i>
                        </div>
                        <div className="directory__form-group">
                            <select className="directory__form-input" name="type" id="type" defaultValue={0}>
                                <option value="0" disabled>Select Type</option>
                                <option value="1">Beginner</option>
                                <option value="2">Moderate</option>
                                <option value="3">Challenging</option>
                                <option value="4">Strenous</option>
                            </select>
                            <i className="fa-solid fa-chevron-down"></i>
                        </div>
                        <div className="directory__form-group">
                            <select className="directory__form-input" name="duration" id="duration" defaultValue={0}>
                                <option value="0" disabled>Select Duration</option>
                                <option value="1">Beginner</option>
                                <option value="2">Moderate</option>
                                <option value="3">Challenging</option>
                                <option value="4">Strenous</option>
                            </select>
                            <i className="fa-solid fa-chevron-down"></i>
                        </div>
                    </form>
                </div>
                <div className="directory__events">
                    {adventures?.data?.results?.map((adventure) => {
                        return (
                            <div className="=directory__events-card">
                                <EventCard detailed={true} buttonType={BUTTON_TYPE_CLASSES.eventButton} link={`/events/details/${adventure.id}`} adventure={adventure}/>
                            </div>
                        )
                    })}
                </div>
               
            </div>

            <div className="u-footer-height">
                    <Footer/>
            </div>
        </>
    )
}

export default EventsDirectory;